import React, { useState, useEffect } from 'react';
import { Table, Button, Row, Col, message } from 'antd';
import moment from 'moment';
import { connect } from 'react-redux';
import { addIndustry, resetAddIndustry } from 'appRedux/actions/Industry';
import Widget from 'components/Widget';
import convertToSlug from '../../util/convertToSlug';
import { EditableCell, EditableFormRow } from './EditableCell';
import Columns from './Columns';

const InsertIndustry = ({ addIndustry, resetAddIndustry, updating, payload, currentUser }) => {
  const [dataSource, setDataSource] = useState([
    {
      key: 0,
      name: '',
    }
  ]);
  const [disableSubmit, setDisableSubmit] = useState(true);
  const [count, setCount] = useState(1);
  const [isReset, setIsReset] = useState(false);

  const components = {
    body: {
      row: EditableFormRow,
      cell: EditableCell,
    },
  };

  const isNotAllowSubmit = disableSubmit || dataSource.length === 0;

  const handleDelete = key => {
    const data = [...dataSource];
    setDataSource(data.filter(item => item.key !== key));
  };

  const columns = Columns(handleDelete).map(col => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: record => ({
        record,
        editable: col.editable,
        dataIndex: col.dataIndex,
        title: col.title,
        handleSave: handleUpdateRow,
        handleError: handleError,
        isEditable: true,
        isReset: isReset,
      }),
    };
  });

  const handleReset = (e) => {
    e.preventDefault();
    setDisableSubmit(true);
    setCount(1);
    setIsReset(true);
    setDataSource([]);
  };

  const handleAdd = (e) => {
    e.preventDefault();
    const newData = {
      key: count,
      name: '',
    };
    setDataSource([...dataSource, newData]);
    setCount(count + 1);
  };

  const handleUpdateRow = row => {
    const newData = [...dataSource];
    const index = newData.findIndex(item => row.key === item.key);
    const item = newData[index];
    newData.splice(index, 1, {
      ...item,
      ...row,
    });
    setDataSource(newData);
  };

  const handleSave = (e) => {
    e.preventDefault();
    const validData = dataSource.filter(item => item.name);
    if (validData.length === 0) {
      message.error({ content: 'Dữ liệu bạn nhập chưa đầy đủ thông tin', key: 'updatable', duration: 2 });
      return;
    }

    const params = validData.map((item, i) => ({
      key: convertToSlug(item.name),
      name: item.name,
      created_by: currentUser,
      created_at: moment().unix(),
    }));

    addIndustry({ params });
  };

  const handleError = (isDisabled) => {
    setDisableSubmit(isDisabled);
  };

  useEffect(() => {
    if (payload.message) {
      if (payload.code === 200) {
        message.success({ content: payload.message, key: 'updatable', duration: 2 });
      } else {
        message.error({ content: payload.message, key: 'updatable', duration: 2 });
      }
      resetAddIndustry();
    }
  }, [payload.code, payload.message, resetAddIndustry]);

  return (
    <>
      <Row>
        <Col span={24}>
          <Widget
            styleName="gx-order-history"
            title={<h2 className="h4 gx-text-capitalize gx-mb-0">Thêm dữ liệu Industry</h2>}
          >
            <Button icon='plus' onClick={handleAdd} type="primary" style={{ marginBottom: 16 }}>
              Thêm industry
            </Button>
            <Table
              className='gx-table-no-bordered'
              pagination={false}
              bordered={false}
              size='small'
              components={components}
              rowClassName={() => 'editable-row'}
              dataSource={dataSource}
              columns={columns}
            />
            <div className='save-segment'>
              <Button disabled={isNotAllowSubmit} loading={updating} onClick={handleSave} icon='vertical-align-bottom' size='large' type="primary">
                Save
              </Button>
              <Button disabled={updating} onClick={handleReset} icon='undo' size='large'>
                Reset
              </Button>
            </div>
          </Widget>
        </Col>
      </Row>
    </>
  );
}

const mapStateToProps = ({ auth, industry }) => {
  const { currentUser } = auth;
  const { updating, payload } = industry;
  return { updating, payload, currentUser };
};

export default connect(
  mapStateToProps,
  { addIndustry, resetAddIndustry }
)(InsertIndustry);
